import request from '@/service/request'
enum Api {
  GET_DICT_TYPE = '/dict/getDict',
  ADD_DICT_TYPE = '/dict/addDict',
  EDIT_DICT_TYPE = '/dict/updateDict',
  DELETE_DICT_TYPE = '/dict/delDict',
  ADD_DICT_VALUE = '/dict-value/addDictValue',
  EDIT_DICT_VALUE = '/dict-value/updateDictValue',
  GET_DICT_VALUE = '/dict-value/getDictValue',
  DELETE_DICT_VALUE = '/dict-value/delDictValue',
  REFRESH_REDIS = '/dict-value/refresh'
}

export default class dataDictionaryService {
  /**
   * 获取数据字典类型
   * @param data
   * @returns
   */
  static getDictType(data: any): Promise<any> {
    return request.post(Api.GET_DICT_TYPE, data)
  }

  /**
   * 新增数据字典类型
   * @param data
   * @returns
   */
  static addDictType(data: any): Promise<any> {
    return request.post(Api.ADD_DICT_TYPE, data)
  }

  /**
   * 修改数据字典类型
   * @param data
   * @returns
   */
  static editDictType(data: any): Promise<any> {
    return request.post(Api.EDIT_DICT_TYPE, data)
  }

  /**
   * 删除数据字典类型
   * @param data
   * @returns
   */
  static deleteDictType(data: any): Promise<any> {
    return request.post(Api.DELETE_DICT_TYPE, data)
  }

  /**
   * 新增数据字典值
   * @param data
   * @returns
   */
  static addDictValue(data: any): Promise<any> {
    return request.post(Api.ADD_DICT_VALUE, data)
  }

  /**
   * 修改数据字典值
   * @param data
   * @returns
   */
  static editDictValue(data: any): Promise<any> {
    return request.post(Api.EDIT_DICT_VALUE, data)
  }

  /**
   * 获取数据字典值
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post(Api.GET_DICT_VALUE, data)
  }

  /**
   * 删除数据字典值
   * @param data
   * @returns
   */
  static deleteDictValue(data: any): Promise<any> {
    return request.post(Api.DELETE_DICT_VALUE, data)
  }

  /**
   * redis缓存刷新
   * @param data
   * @returns
   */
  static refreshRedis(data: any): Promise<any> {
    return request.post(Api.REFRESH_REDIS, data)
  }
  /**
   * 获取数据字典
   * @param data any
   * @returns Promise
   */
  static getListDictData(data: any): Promise<any> {
    return request.post('/dict-value/listDictData', data)
  }
}
